// Phase 3 — Navigation Architecture
//
// Navigation Domains are a presentation/grouping taxonomy used by
// NavigationRegistry to compose menus. They are distinct from (but
// compatible with) the Phase 1 Trust Domains (`COMMUNITY`/`CHURCH` in
// `contexts/DomainContext.js`).
//
// - COMMUNITY / CHURCH map directly onto the Phase 1 trust domains.
// - PERSONAL / CIRCLE are sub-contexts that exist within either trust
//   domain (a Personal Circle is COMMUNITY trust domain; a Church-Owned
//   Circle is CHURCH trust domain).
//
// Navigation domain tagging is presentation/grouping only and must never be
// used as an authorization mechanism — route guards continue to rely on the
// existing Phase 1/2 trust-domain and permission checks
// (assertChurchDomainAccess, assertCircleAccess, ProtectedRoute).
// See docs/architecture/PHASE3_ARCHITECTURE_REVIEW.md §3.

export const NAV_DOMAINS = Object.freeze({
  COMMUNITY: "COMMUNITY",
  CHURCH: "CHURCH",
  PERSONAL: "PERSONAL",
  CIRCLE: "CIRCLE",
});

// Navigation Contexts (Step 4 — Context Switching). A superset of
// NAV_DOMAINS that also covers contexts without a dedicated nav domain yet
// (Ministry/Group placeholders pending Phase 8/9).
export const NAV_CONTEXTS = Object.freeze({
  PERSONAL: "PERSONAL",
  CHURCH: "CHURCH",
  CIRCLE: "CIRCLE",
  MINISTRY: "MINISTRY",
  GROUP: "GROUP",
});
